import api from './data';

export { api };
